import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=22faf8d8&scoped=true&"
import script from "./EditUser.vue?vue&type=script&lang=js&"
export * from "./EditUser.vue?vue&type=script&lang=js&"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=22faf8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22faf8d8",
  null
  
)

export default component.exports